<template>
    <div class="optional_container" :disabled="disabled" :title="title" @click.self="check()">
        <input ref="checkbox" class="checkbox" type="checkbox" :checked="modelValue" :disabled="disabled" @change="$emit('update:modelValue', $event.target.checked)" />
        <div class="title ellipsis noselect" @click.self="check()">{{ title }}</div>
        <Info>
            <slot></slot>
        </Info>
    </div>
</template>

<script>
import Info from "./info.vue";

export default {
    name: "Optional",
    components: {
        Info,
    },
    props: ["title", "disabled", "modelValue"],
    emits: ["update:modelValue"],
    methods:{
        async check(){            
            this.$refs.checkbox.click()
        }
    }
};
</script>

<style scoped>
.optional_container {
    margin: 5px 0px;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: flex-start;
    text-align: left;
    background: rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.1);
    
    height: 30px;
    overflow: hidden;
    cursor: pointer;
}

.optional_container > .checkbox {
    cursor: pointer;
    margin: auto 5px;
}

.optional_container > .title {
    margin: auto 5px;
    flex-grow: 1;
    flex-shrink: 1;
    font-size: 12pt;
    color: black;
}
</style>
